import { Api } from '@coderhouse/common'
import { Toast, ToastLinks } from '@/models/toast-social-sharing'

const { VUE_APP_CH_API_BFF } = process.env

async function getToast(): Promise<Toast[]> {
  const toastInfo = await Api.get(`${VUE_APP_CH_API_BFF}/v1/home/notifications-social-sharing`)
  const item = toastInfo[0]
  return item
}

async function omitSocialSharingNoti(notificationId: string): Promise<Toast> {
  const response = await Api.put(`${VUE_APP_CH_API_BFF}/v1/home/notifications-social-sharing/${notificationId}/readed`, {})
  return response
}

async function shareSocialSharingNoti(notificationId: string): Promise<Toast> {
  const response = await Api.put(`${VUE_APP_CH_API_BFF}/v1/home/notifications-social-sharing/${notificationId}/shared`, {})
  return response?.linkedin_share_link
}

export { getToast, omitSocialSharingNoti, shareSocialSharingNoti }
